/** @jsxImportSource @emotion/react */

import { useState } from 'react'

import HouseIcon from 'apollo-react-icons/House'
import DocumentsIcon from 'apollo-react-icons/FileDocuments'
import Dashboard from 'apollo-react-icons/Dashboard'
import Handshake from 'apollo-react-icons/Handshake'
import FileAward from 'apollo-react-icons/FileAward'
import SettingsIcon from 'apollo-react-icons/Cog'

import Sidebar from 'apollo-react/components/Sidebar'
import IDSThemeProvider from 'apollo-react/utils/IDSThemeProvider'

const TestableHouseIcon = props => <HouseIcon title="HouseIcon" {...props} />
const TestableDocumentsIcon = props => (
  <DocumentsIcon title="DocumentsIcon" {...props} />
)
const TestableDashboard = props => <Dashboard title="Dashboard" {...props} />
const TestableHandshake = props => <Handshake title="Handshake" {...props} />
const TestableFileAward = props => <FileAward title="FileAward" {...props} />
const TestableSettingsIcon = props => (
  <SettingsIcon title="SettingsIcon" {...props} />
)

const menuIcons = {
  studyHome: TestableHouseIcon,
  documents: TestableDocumentsIcon,
  siteActivation: TestableDashboard,
  studyTools: TestableHandshake,
  training: TestableFileAward,
  admin: TestableSettingsIcon,
}

const IDSSidebarEmbed = ({ data = {} }) => {
  const menuItems = Object.keys(data).map(key => {
    const { highlightMatcher, ...sidebarProps } = data[key]

    return {
      ...sidebarProps,
      icon: menuIcons[key],
    }
  })

  const [minWidth, setMinWidth] = useState('320px')

  const onToggleCollapsed = () => {
    if (minWidth === '320px') {
      setMinWidth('64px')
    } else {
      setMinWidth('320px')
    }
  }

  function activeMenuItemText() {
    const menuItemsData = Object.values(data)
    let text

    menuItemsData.forEach(value => {
      if (value.pathname === window.location.pathname) text = value.text
    })

    if (text) return text

    menuItemsData
      .filter(value => value.menuItems)
      .forEach(value => {
        return value.menuItems.forEach(subMenuItem => {
          if (subMenuItem.pathname === window.location.pathname)
            text = subMenuItem.text
        })
      })

    if (text) return text

    menuItemsData.forEach(value => {
      if (
        window.location.pathname.match(new RegExp(`^${value.highlightMatcher}`))
      )
        text = value.text
    })

    if (text) return text

    menuItemsData
      .filter(value => value.menuItems)
      .forEach(value => {
        return value.menuItems.forEach(subMenuItem => {
          if (
            window.location.pathname.match(
              new RegExp(`^${subMenuItem.highlightMatcher}`)
            )
          )
            text = subMenuItem.text
        })
      })

    return text
  }

  return (
    <>
      <IDSThemeProvider themeName="patientLight">
        <Sidebar
          data-testid="sidebar"
          sx={{
            'a:visited': {
              color: 'white !important',
            },
            '& .MuiPaper-root': {
              width: '320px',
              marginTop: '62px',
              height: 'calc(100vh - 62px) !important',
            },
          }}
          variant="brand"
          checkIsActive={item =>
            item.text === activeMenuItemText() ||
            item.menuItems?.some(
              subItem => subItem.text === activeMenuItemText()
            )
          }
          onClick={item => (window.location.href = item.pathname)}
          menuItems={menuItems}
          backgroundColor={'#012865'}
          onToggleCollapsed={onToggleCollapsed}
          logoComponentProps={{
            orgName: '',
            appName: '',
          }}
        />
      </IDSThemeProvider>
      <div
        css={{
          display: 'inline-block',
          height: '100vh',
          minWidth,
        }}
      ></div>
    </>
  )
}

export default IDSSidebarEmbed
